import React from 'react';
import Currency from 'react-currency-formatter';
import { useParams } from 'react-router';

// material-ui
import { TableCell, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
//import customGlobalStyle from 'Components/assets/jss/material-dashboard-pro-react/customGlobalStyle';
import { Warning } from '@mui/icons-material';
import { useLanguageReference } from 'services/Hooks/useLanguageReference';
import ThemedTooltip from '@acnb/CustomComponents/Tooltip/ThemedTooltip';
import { useAllInventoryItems } from 'services/Data/InventoryItemServices';
import { useCeiling } from 'services/Data/ProjectServices';

// Icons

// Styles

// Actions

// Components

// Others

const useStyles = makeStyles(theme => ({
  // ...customGlobalStyle(theme),
  ceilingCell: {
    maxWidth: '180px',
    textTransform: 'uppercase',
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    fontSize: 'medium',
  },
  packagePrice: {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    fontSize: 'medium',
    textAlign: 'center',
  },
  tableRow: {
    '& td': {
      padding: '10px',
    },
  },
}));

const DealerCopyGroupedCeilingSection = ({
  categoryLabel,
  projectInventoryItems,
  ceilingId,
  headerColSpan,
  projectCurrency,
  setWarningModalInfo,
}) => {
  const classes = useStyles();

  let { projectId } = useParams();

  const { descriptionReference, nameReference, warningReference, warningReferenceFallback } = useLanguageReference();
  const { data: availableInventoryItems } = useAllInventoryItems();

  const { data: ceiling, isLoading: isLoadingCeiling } = useCeiling(projectId, ceilingId);

  const totalForSection = projectInventoryItems.reduce((acc, cur) => acc + cur.projectDealerTotalPrice, 0);

  if (isLoadingCeiling) return null;

  return (
    <>
      <TableRow>
        <TableCell colSpan={headerColSpan} style={{ backgroundColor: '#c9c7c7' }}>
          <strong>{categoryLabel}</strong>
        </TableCell>
      </TableRow>
      {projectInventoryItems
        ?.filter(projectInventoryItem => projectInventoryItem.quantity)
        ?.map((ceilingInventoryItem, index) => {
          let inventoryItem = availableInventoryItems?.find(as => as.id === ceilingInventoryItem.inventoryItem_Id);
          return (
            <TableRow
              className={classes.tableRow}
              key={ceilingInventoryItem.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              {index === 0 && (
                <TableCell className={classes.ceilingCell} rowSpan={projectInventoryItems.length}>
                  {`${ceiling?.[nameReference]}`}
                  <br />
                </TableCell>
              )}
              <TableCell>
                {(inventoryItem?.[warningReference] || inventoryItem?.[warningReferenceFallback]) && (
                  <ThemedTooltip
                    title={inventoryItem?.[warningReference] || inventoryItem?.[warningReferenceFallback]}
                    placement={'top'}>
                    <Warning
                      color="warning"
                      style={{ cursor: 'pointer' }}
                      sx={{ mr: 1 }}
                      onClick={() => {
                        setWarningModalInfo({ open: true, inventoryItem });
                      }}
                    />
                  </ThemedTooltip>
                )}
                <strong>{`${inventoryItem?.sku}`}</strong>
              </TableCell>
              <TableCell>{ceilingInventoryItem?.[descriptionReference]}</TableCell>
              <TableCell align="center">{ceilingInventoryItem.quantity || '0'}</TableCell>
              <TableCell align="right">
                {ceilingInventoryItem.projectDealerUnitPrice === 0 ? (
                  '-'
                ) : (
                  <Currency quantity={ceilingInventoryItem.projectDealerUnitPrice} currency={projectCurrency} />
                )}
              </TableCell>

              <TableCell align="right">
                {ceilingInventoryItem.projectDealerTotalPrice === 0 ? (
                  '-'
                ) : (
                  <Currency quantity={ceilingInventoryItem.projectDealerTotalPrice} currency={projectCurrency} />
                )}
              </TableCell>

              {index === 0 && (
                <TableCell className={classes.packagePrice} rowSpan={projectInventoryItems.length}>
                  <Currency quantity={totalForSection} currency={projectCurrency} />
                </TableCell>
              )}
            </TableRow>
          );
        })}
    </>
  );
};

export default DealerCopyGroupedCeilingSection;
